import { useState } from 'react'
import { Link } from 'react-router-dom'
import iconArrowRightBig from '../../../assets/icons/ico-arrow-right-big.png'
import IconArrowRightWhite from '../../../assets/icons/ico-arrow-right-white.png'
import { Item } from './styles'
import { Person, PersonAdd, KeyboardArrowDown } from '@mui/icons-material'

const UserMenuItem = ({ icon = null, title, url = null, hasDrop = false, itens, level = 0, action = null, type = null, actionSubItem = null }) => {
  const [isOpen, setIsOpen] = useState({})

  const handleOpen = (title: string) => {
    setIsOpen((prev) => {
      const opens = {}

      Object.keys(prev).forEach(open => {
        Object.assign(opens, { [open]: false })
      })

      return (
        {
          ...opens,
          [title]: !prev[title]
        }
      )
    })
  }

  return (
    <Item>
      {hasDrop
        ? (
          <div className="user-menu-dropdown" onClick={() => handleOpen(title)}>
            <div className="user-menu-item-sections">
              <div>
                {
                  icon && type === 'meusDados' && (
                    <Person style={{ color: '#8C2458', fontSize: 26 }} />
                  )
                }

                {
                  icon && type === 'usuarioFazendas' && (
                    <PersonAdd style={{ color: '#8C2458', fontSize: 26 }} />
                  )
                }
                <span>{title}</span>
              </div>
              <KeyboardArrowDown style={{ color: '#8C2458', fontSize: 26 }} />
            </div>
            {isOpen[title] && (
              <div className="user-menu-dropdown-list">
                {itens?.map((item, index) => (
                  item?.action
                    ? <UserMenuItem key={`${index} - ${title}`} {...item} level={1} action={() => item.action()} />
                    : <UserMenuItem key={`${index} - ${title}`} {...item} level={1} actionSubItem={() => item.actionSubItem()} />
                ))}
              </div>
            )}
          </div>
        )
        : (action
          ? <div onClick={() => { if (title === 'Sair') { sessionStorage.removeItem('ccNotification') } action() }} className="user-menu-item-sections">
            {icon && <img src={icon} alt={title} />}
            <h3>{title}</h3>
            <img className="user-menu-arrow" src={level === 1 ? IconArrowRightWhite : iconArrowRightBig} alt="icone de seta" />
          </div>
          : <Link
            onClick={() => {
              actionSubItem()
            }}
            to={url}
            className="user-menu-item-sections"
          >
            {
              icon && <img src={icon} alt={title} />
            }
            <h3>{title}</h3>
            <img className="user-menu-arrow" src={level === 1 ? IconArrowRightWhite : iconArrowRightBig} alt="icone de seta" />
          </Link>
        )}
    </Item>
  )
}

export default UserMenuItem
